var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgShowPassword = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "show password@4x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landowners",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landowner-sign-in",
    transform: "translate(-1123.000000, -573.000000)",
    fill: "#4A5569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24pt/ic_eye_on",
    transform: "translate(1121.000000, 569.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_eye_on",
    fill: "none",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fill: "#000000",
    opacity: 0,
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C14.8211879,4 17.2852057,5.35001745 19.3748814,7.5635258 C20.0902915,8.32133052 20.711169,9.12994153 21.2374574,9.93918061 C21.4763263,10.3064736 21.6593662,10.6160147 21.7857317,10.8466879 L21.7857317,10.8466879 L21.8931745,11.0502898 C22.0356085,11.3331795 22.0356085,11.6668205 21.8931745,11.9497102 C21.7751896,12.1840414 21.5559492,12.5710954 21.2374574,13.0608194 C20.711169,13.8700585 20.0902915,14.6786695 19.3748814,15.4364742 C17.2852057,17.6499825 14.8211879,19 12,19 C9.17881215,19 6.71479428,17.6499825 4.62511857,15.4364742 C3.90970851,14.6786695 3.28883097,13.8700585 2.76254262,13.0608194 C2.52367373,12.6935264 2.34063381,12.3839853 2.21426827,12.1533121 L2.21426827,12.1533121 L2.10682549,11.9497102 C1.9643915,11.6668205 1.9643915,11.3331795 2.10682549,11.0502898 C2.22481042,10.8159586 2.44405076,10.4289046 2.76254262,9.93918061 C3.28883097,9.12994153 3.90970851,8.32133052 4.62511857,7.5635258 C6.71479428,5.35001745 9.17881215,4 12,4 Z M12,6 C9.80982422,6 7.82497845,7.08748255 6.07942688,8.9364742 C5.4525074,9.60054448 4.90364062,10.315371 4.43916193,11.0295694 C4.40466588,11.0826117 4.3716153,11.1340844 4.34001876,11.1838869 L4.34001876,11.1838869 L4.144,11.5 L4.24959981,11.6718169 L4.43916193,11.9704306 C4.90364062,12.684629 5.4525074,13.3994555 6.07942688,14.0635258 C7.82497845,15.9125175 9.80982422,17 12,17 C14.1901758,17 16.1750216,15.9125175 17.9205731,14.0635258 C18.5474926,13.3994555 19.0963594,12.684629 19.5608381,11.9704306 C19.5953341,11.9173883 19.6283847,11.8659156 19.6599812,11.8161131 L19.6599812,11.8161131 L19.855,11.5 L19.7504002,11.3281831 L19.5608381,11.0295694 C19.0963594,10.315371 18.5474926,9.60054448 17.9205731,8.9364742 C16.1750216,7.08748255 14.1901758,6 12,6 Z M12,8.0625 C13.9063388,8.0625 15.4545455,9.5999552 15.4545455,11.5 C15.4545455,13.4000448 13.9063388,14.9375 12,14.9375 C10.0936612,14.9375 8.54545455,13.4000448 8.54545455,11.5 C8.54545455,9.5999552 10.0936612,8.0625 12,8.0625 Z M12,10.0625 C11.1951228,10.0625 10.5454545,10.7076566 10.5454545,11.5 C10.5454545,12.2923434 11.1951228,12.9375 12,12.9375 C12.8048772,12.9375 13.4545455,12.2923434 13.4545455,11.5 C13.4545455,10.7076566 12.8048772,10.0625 12,10.0625 Z",
    id: "Fill",
    fill: "#9393AA"
  })))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShowPassword, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/show-password.1f3c3ab6.svg";
export { ForwardRef as ReactComponent };